import LoginButtonTemplate from "./LoginButtonTemplate";
import { isLoggedIn } from "api/coachAuth";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useGoogleLoginCoach from "../../hooks/useGoogleLoginCoach";

export default function GoogleLoginButtonCoach({
  render,
  onNotCoach,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  onNotCoach?: () => void;
}) {
  const handleGoogleLogin = useGoogleLoginCoach(onNotCoach);
  const user = useRecoilValue(userAtom);

  return (
    <LoginButtonTemplate
      loginType="google"
      action={() => {
        handleGoogleLogin();
      }}
      isLoggedIn={isLoggedIn(user)}
      widthPx={320}
      heightPx={54}
      hideRecentLabel
    />
  );
}
